import { render, staticRenderFns } from "./filter-results.vue?vue&type=template&id=0d61ad27"
import script from "./filter-results.vue?vue&type=script&lang=js"
export * from "./filter-results.vue?vue&type=script&lang=js"
import style0 from "./filter-results.vue?vue&type=style&index=0&id=0d61ad27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports